import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
Vue.use(Vuex)
const state = {
  currentTrip: {},
  currentDest: false,
  rightPanelActive: false,
  galleryActive: false,
  subPanelActive: false,
  contactActive: false,
  regions: [],
  types: []
}

const mutations = {
  SET_REGIONS (state, regions) {
    state.regions = regions
  },
  SET_TYPES (state, types) {
    state.types = types
  },
  UPDATE_REGION (state, region) {
    region.value = !region.value
  },
  UPDATE_TYPE (state, type) {
    type.value = !type.value
  },
  SET_CURRENT_TRIP (state, trip) {
    state.currentTrip = trip
  },
  CLOSE_RIGHT_PANEL (state) {
    state.rightPanelActive = false
  },
  OPEN_RIGHT_PANEL (state) {
    state.rightPanelActive = true
  },
  CLOSE_GALLERY (state) {
    state.galleryActive = false
  },
  OPEN_GALLERY (state) {
    state.galleryActive = true
  },
  SET_CURRENT_DEST (state, destination) {
    state.currentDest = destination
  },
  OPEN_SUBMIT_PANEL (state) {
    state.subPanelActive = true
  },
  CLOSE_SUBMIT_PANEL (state) {
    state.subPanelActive = false
  },
  OPEN_CONTACT_PANEL (state) {
    state.contactActive = true
  },
  CLOSE_CONTACT_PANEL (state) {
    state.contactActive = false
  }
}

export default new Vuex.Store({
  state,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/vuex/store.js